// extracted by mini-css-extract-plugin
export default {"container":"Transfer_container__e+JLS","main":"Transfer_main__vHrcJ","body":"Transfer_body__62N00"};